import { FC } from 'react'
import { BaseEdge, EdgeProps, getStraightPath } from 'reactflow'

export const TankEdge: FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  style,
  markerEnd,
}) => {
  if (sourceX == null || sourceY == null || targetX == null || targetY == null) {
    return null
  }


  const [edgePath] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  })

  if (!edgePath) {
    return null
  }

  return <BaseEdge id={id} path={edgePath} style={style} markerEnd={markerEnd} />
}
